import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { getAllTutorialCookies } from '../../../utils/Tutorial';
import { useCookies } from 'react-cookie';
import NextStep2Modal from '../Step2/NextStep2Modal';
import NextStep3Modal from '../Step3/NextStep3Modal';
import CheckWorkingStep from './CheckWorkingStep';
import { useTutorialContext } from '../../GuideTour/TutorialProvider';

export default function CheckWaitingTutorial({ notCompletedSetting, currentUser }) {
  const [cookie] = useCookies(['currentUserEmail'])
  const [isCurrentUser, setIsCurrentUser] = useState()
  const [tutorialStep1, setTutorialStep1] = useState()
  const [tutorialStep2, setTutorialStep2] = useState()
  const [tutorialStep3, setTutorialStep3] = useState()
  const [isStep2ReadyStart, setIsStep2ReadyStart] = useState()
  const [isStep3ReadyStart, setIsStep3ReadyStart] = useState()
  const { addUser } = useTutorialContext()
  
  useEffect(() => {
    const checkIscurrentUser = currentUser.email == cookie['currentUserEmail']
    if (checkIscurrentUser) {
      setIsCurrentUser(checkIscurrentUser)
      const { tutorialStep1, tutorialStep2, tutorialStep3 } = getAllTutorialCookies(currentUser.email) || {}
      setTutorialStep1(tutorialStep1)
      setTutorialStep2(tutorialStep2)
      setTutorialStep3(tutorialStep3)
      setIsStep2ReadyStart((notCompletedSetting.length == 2) && !tutorialStep1 && !tutorialStep2)
      setIsStep3ReadyStart((notCompletedSetting.length == 1) && !tutorialStep2 && !tutorialStep3)
    }
  }, [cookie['currentUserEmail']])

  useEffect(() => {
    addUser(currentUser.email)
  }, [])

  return (
    <React.Fragment>
      {isStep2ReadyStart && isCurrentUser && <NextStep2Modal />}
      {isStep3ReadyStart && isCurrentUser && <NextStep3Modal />}
      {tutorialStep1 && isCurrentUser && <CheckWorkingStep.Step1 cookie={tutorialStep1} />}
      {tutorialStep2 && isCurrentUser && <CheckWorkingStep.Step2 cookie={tutorialStep2} />}
      {tutorialStep3 && isCurrentUser && <CheckWorkingStep.Step3 cookie={tutorialStep3} />}
    </React.Fragment>
  )
}

